import { Controller } from "@hotwired/stimulus"

// Chrome-owned: the persistent <turbo-frame id="modal"> lives in the host layout,
// so its controller lives in the host too (domain JS stays in the engine). Opens
// the native <dialog> when the frame is filled; Escape/native dismissal is free.
// Backdrop click closes it via a data-action wired on the <dialog> itself.
export default class extends Controller {
  connect() {
    if (!this.element.open) this.element.showModal()
  }

  disconnect() {
    if (this.element.open) this.element.close()
  }

  close() {
    this.element.close()
  }

  backdropClose(event) {
    if (event.target === this.element) this.close()
  }
}
